import React from 'react'
import { useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client';
import ListNames from '../../../common/ListNames';
import { sendTeamSalesThankYouEmailMutation } from '../../../queries/team';
import { FiEdit, FiSend } from 'react-icons/fi';
import { FaChevronRight } from 'react-icons/fa6';

function Team({ user, associationId, team, setEditing }) {
  const history = useHistory();

  const [sendThankYouEmail, { loading: sendingEmail }] = useMutation(sendTeamSalesThankYouEmailMutation);

  const handleSendThankYouEmail = async (e) => {
    e.stopPropagation();

    if (!window.confirm('Du kommer nu att skicka ett tackmail till lagets administratörer för deras insats i försäljningen. Vill du fortsätta?'))
      return;

    try {
      await sendThankYouEmail({
        variables: {
          teamId: team._id
        }
      });
      alert('Tackmail skickat till lagets administratörer!');
    } catch (error) {
      console.error('Error sending thank you email:', error);
      alert('Fel vid skickande av tackmail: ' + error.message);
    }
  };

  // Check if sales period has ended
  const salesPeriodEnded = team.salesEndDate && new Date(team.salesEndDate) < new Date();

  return (
    <tr className='c-pointer' onClick={() => {
      history.push({
        pathname: `/cities/associations/${associationId}/teams/${team._id}/sales`,
        state: {
          previousRoute: history.location.pathname
        }
      });
    }}>
      <td>
        <p className={` m-0 ${team.adminUsers.length === 0 ? 'inactive' : ''}`}>
          {team.name}
        </p>
        {team.adminInvitations === null && team.adminUsers.length === 0 && <span className='small inactive'>Lagledare saknas</span>}
        {team?.adminUsers?.length > 0 && <ListNames admins={team?.adminUsers} />}
        {team?.adminInvitations?.filter(admin => admin.userIdActivated === null).length > 0 &&
          <span className='small inactive'>Inväntar {team?.adminInvitations?.filter(admin => admin.userIdActivated === null).length} lagledares aktivering...</span>
        }
      </td>
      <td>
        <div className="table-icon-buttons">
          {user.superAdmin && salesPeriodEnded && (
            <div
              className="table-icon-btn"
              role="button"
              tabIndex={0}
              title={sendingEmail ? 'Skickar...' : 'Skicka ut tackmail'}
              onClick={(e) => { e.stopPropagation(); handleSendThankYouEmail(e); }}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); handleSendThankYouEmail(e); } }}
              style={{ opacity: sendingEmail ? 0.5 : 1, pointerEvents: sendingEmail ? 'none' : 'auto' }}
            >
              <FiSend size={14} />
            </div>
          )}
          {user.superAdmin && (
            <div
              className="table-icon-btn"
              role="button"
              tabIndex={0}
              title="Redigera"
              onClick={(e) => { e.stopPropagation(); setEditing(team._id); }}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.stopPropagation(); setEditing(team._id); } }}
            >
              <FiEdit size={14} />
            </div>
          )}
          <div className="table-icon-btn">
            <FaChevronRight size={14} />
          </div>
        </div>
      </td>
    </tr>
  )
}

export default Team
